import styled, { css } from 'styled-components';

export const StatusMenuContainer = styled.div<{
  itemActive?: string;
  size?: 'small' | 'default';
}>`
  .ant-tabs,
  .ant-tabs-nav {
    margin: 0 !important;
  }

  .ant-tabs-nav:before {
    border-bottom: 1px solid transparent !important;
  }

  .ant-tabs-ink-bar {
    display: none;
  }

  .ant-tabs-tab {
    margin: 0 4px !important;
    padding: 4px 0 !important;
    border: 1px solid ${({ theme }) => theme.colors.border};
    border-radius: ${({ theme }) => theme.shapes.borderRadius};

    span {
      line-height: 1rem;
    }
  }

  .ant-tabs-tab-active {
    ${({ theme, itemActive }) =>
      itemActive &&
      css`
        background: ${theme.colors.background} !important;
        border-color: ${theme.colors.primary} !important;
      `};
  }

  .status-menu-card-layout-horizontal {
    flex-direction: row;
    align-items: center;
    padding: 0;

    .ant-statistic-content {
      font-size: ${({ size }) => (size === 'small' ? 0.9 : 1.1)}rem;
    }

    .status-menu-title-with-total {
      margin-left: 12px;
    }
  }

  .status-menu-button-all {
    margin: 6px 4px;
    background: ${({ theme }) => theme.colors.background} !important;
    color: ${({ theme }) => theme.colors.text1};
    padding: 4px 8px;

    .status-menu-all {
      margin-right: 8px;
      color: ${({ theme }) => theme.colors.primary};
    }
  }

  .anticon-ellipsis {
    color: ${({ theme }) => theme.colors.text};
  }

  .ant-btn {
    margin-left: 8px;

    .anticon {
      font-size: 1rem;
      margin-right: 0;
    }
  }
`;

export const TabContainer = styled.div`
  display: inline-flex;
  flex-direction: column;
  padding: 8px;
  margin: 0 8px;
  transition: 0.2s;
  border: 3px solid transparent;
  color: ${({ theme }) => theme.colors.text1};
  transition: 0.3s;

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }

  .status-menu-title {
    font-size: ${({ theme }) => theme.fontSizes.small};
  }

  .ant-statistic-content {
    font-size: 1.2rem;
  }

  .status-menu-info {
    margin-left: 6px;
    position: relative;
    right: -4px;
    height: 20px;
    width: 20px;
    display: grid;
    place-items: center;
    font-size: 0.75rem;
    border-radius: 50%;
    border: 1px solid;
  }
`;

export const AdditionalContentContainer = styled.div`
  margin-top: 8px;
`;
